const translations = {
  header: {
    home: { he: 'דף הבית', en: 'Home' },
    services: { he: 'שירותים', en: 'Services' },
    about: { he: 'אודות', en: 'About' },
    contact: { he: 'צור קשר', en: 'Contact' },
    langToggle: { he: 'English', en: 'עברית' },
  },
  hero: {
    tagline: {
      he: 'שירותי הכנת דוחות מס אמריקאיים וייעוץ לישראלים אמריקאיים',
      en: 'U.S. tax preparation and consulting services for American Israelis',
    },
    servicesBtn: { he: 'השירותים שלנו', en: 'Our Services' },
    contactBtn: { he: 'צור קשר', en: 'Contact Us' },
    statYears: { he: 'שנות ניסיון', en: 'Years of Experience' },
    statClients: { he: 'לקוחות מרוצים', en: 'Satisfied Clients' },
    statCountries: { he: 'מדינות', en: 'Countries' },
  },
  services: {
    title: { he: 'השירותים שלנו', en: 'Our Services' },
    subtitle: {
      he: 'מספקים פתרונות מקצועיים בתחומי המיסוי בארה"ב תוך התחשבות בחוק הישראלי',
      en: 'Providing professional solutions in U.S. taxation while considering Israeli law',
    },
    cards: [
      {
        title: { he: 'הכנת דוחות מס אמריקאיים', en: 'U.S. Tax Return Preparation' },
        description: {
          he: 'הכנת דוחות מס פדרליים ומדינתיים לאזרחים אמריקאיים ובעלי גרין קארד המתגוררים בישראל',
          en: 'Federal and state tax return preparation for U.S. citizens and green card holders residing in Israel',
        },
      },
      {
        title: { he: 'דיווח FBAR', en: 'FBAR Reporting' },
        description: {
          he: 'דיווח על חשבונות בנק זרים (FBAR) בהתאם לדרישות משרד האוצר האמריקאי',
          en: 'Reporting of foreign bank accounts (FBAR) in compliance with U.S. Treasury requirements',
        },
      },
      {
        title: { he: 'תהליך גילוי מרצון', en: 'Streamlined Filing Procedures' },
        description: {
          he: 'הליכי דיווח במסגרת Streamlined Filing Procedures להסדרת חובות דיווח שלא בוצעו',
          en: 'Filing procedures under the Streamlined Filing Compliance program to resolve past-due reporting obligations',
        },
      },
      {
        title: { he: 'ייעוץ לבעלי אזרחות כפולה', en: 'Dual Citizenship Tax Consulting' },
        description: {
          he: 'ייעוץ לאזרחים בעלי אזרחות כפולה בנוגע להשלכות מס ותכנון אסטרטגי',
          en: 'Tax consulting for dual citizens regarding tax implications and strategic planning',
        },
      },
    ],
  },
  about: {
    title: { he: 'אודות החברה', en: 'About the Company' },
    subtitle: {
      he: 'חברה מובילה להגשת דוחות מס בארה"ב עם שנים של ניסיון',
      en: 'A leading U.S. tax filing firm with years of experience',
    },
    whoWeAre: { he: 'מי אנחנו', en: 'Who We Are' },
    whoWeAreParagraph1: {
      he: 'ב־<strong>LevitzTax</strong> אנו מתמחים בליווי אזרחים אמריקאיים ובעלי גרין קארד המתגוררים בישראל, בהתמודדות עם המורכבות של ציות לדיני המס האמריקאיים.',
      en: 'At <strong>LevitzTax</strong>, we specialize in guiding U.S. citizens and green card holders living in Israel through the complexities of American tax compliance.',
    },
    whoWeAreParagraph2: {
      he: 'כמכיני דוחות מס מוסמכים בארה״ב, אנו בעלי ניסיון רב בעבודה עם לקוחות בישראל, במטרה להבטיח עמידה מלאה בדרישות החוק האמריקאי, תוך צמצום הנטל והבלבול הכרוכים במיסוי חוצה־גבולות.',
      en: 'As certified U.S. tax preparers, we have extensive experience working with clients in Israel, ensuring full compliance with American legal requirements while minimizing the burden and confusion of cross-border taxation.',
    },
    featureExperience: { he: 'ניסיון של 5+ שנים', en: '5+ Years of Experience' },
    featureTeam: { he: 'צוות מקצועי ומוסמך', en: 'Professional & Certified Team' },
    featureGlobal: { he: 'פעילות בינלאומית', en: 'International Operations' },
    featureQuality: { he: 'איכות ומקצועיות', en: 'Quality & Professionalism' },
    statClients: { he: 'לקוחות מרוצים', en: 'Satisfied Clients' },
    statYears: { he: 'שנות ניסיון', en: 'Years of Experience' },
    statCountries: { he: 'מדינות פעילות', en: 'Active Countries' },
    statSupport: { he: 'תמיכה זמינה', en: 'Available Support' },
    missionTitle: { he: 'המשימה שלנו', en: 'Our Mission' },
    missionText: {
      he: 'מה שמייחד את LevitzTax הוא רמת הזמינות הגבוהה והליווי האישי לאורך כל התהליך. אנו מלווים כל לקוח צעד אחר צעד בהגשת הדוחות, ודואגים להפוך את החוויה לפשוטה ונטולת לחץ ככל האפשר.',
      en: 'What sets LevitzTax apart is our high level of availability and personal guidance throughout the entire process. We walk every client through the filing process step by step, ensuring the experience is as simple and stress-free as possible.',
    },
    visionTitle: { he: 'החזון שלנו', en: 'Our Vision' },
    visionText: {
      he: 'בואו נפשט את חובות המס האמריקאיות שלכם — עם ליווי אישי, תקשורת ברורה והבנה מעמיקה של האתגרים הייחודיים העומדים בפני נישומים אמריקאים בישראל.',
      en: "Let us simplify your U.S. tax obligations \u2014 with personal guidance, clear communication, and a deep understanding of the unique challenges facing American taxpayers in Israel.",
    },
  },
  contact: {
    title: { he: 'צור קשר', en: 'Contact Us' },
    subtitle: { he: 'נשמח לעזור לך בכל שאלה או בקשה', en: 'We would love to help you with any question or request' },
    formTitle: { he: 'שלח לנו הודעה', en: 'Send Us a Message' },
    errorMessage: {
      he: 'משהו השתבש. נסה שוב או פנה אלינו ישירות בטלפון או במייל.',
      en: 'Something went wrong. Please try again or contact us directly by phone or email.',
    },
    labelName: { he: 'שם מלא *', en: 'Full Name *' },
    labelEmail: { he: 'אימייל *', en: 'Email *' },
    labelPhone: { he: 'טלפון', en: 'Phone' },
    labelMessage: { he: 'הודעה *', en: 'Message *' },
    sending: { he: 'שולח...', en: 'Sending...' },
    sendEmail: { he: 'שלח הודעה', en: 'Send Message' },
    sendWhatsApp: { he: 'שלח בוואטסאפ', en: 'Send via WhatsApp' },
    successTitle: { he: 'תודה! פנייתך התקבלה', en: 'Thank you! Your message has been received' },
    successText: { he: 'ניצור איתך קשר בהקדם האפשרי.', en: 'We will contact you as soon as possible.' },
    sendAnother: { he: 'שליחת הודעה נוספת', en: 'Send Another Message' },
    contactDetails: { he: 'פרטי קשר', en: 'Contact Details' },
    phoneIL: { he: 'טלפון (ישראל)', en: 'Phone (Israel)' },
    phoneUS: { he: 'טלפון (ארה"ב)', en: 'Phone (USA)' },
    email: { he: 'אימייל', en: 'Email' },
    website: { he: 'אתר', en: 'Website' },
    address: { he: 'כתובת', en: 'Address' },
    ourOffice: { he: 'המשרד שלנו', en: 'Our Office' },
    officeCity: { he: 'ירושלים', en: 'Jerusalem' },
    whatsAppTemplate: {
      he: 'שלום, שמי {name}\nאימייל: {email}\nטלפון: {phone}\n\n{message}',
      en: 'Hello, my name is {name}\nEmail: {email}\nPhone: {phone}\n\n{message}',
    },
  },
  footer: {
    description: {
      he: 'U.S. Tax Preparation & Consulting.\nאנו מספקים שירותי הכנת דוחות מס אמריקאיים וייעוץ לישראלים אמריקאיים.',
      en: 'U.S. Tax Preparation & Consulting.\nWe provide American tax return preparation services and consulting for American Israelis.',
    },
    servicesTitle: { he: 'שירותים', en: 'Services' },
    companyTitle: { he: 'חברה', en: 'Company' },
    contactTitle: { he: 'פרטי קשר', en: 'Contact Info' },
    footerAbout: { he: 'אודות', en: 'About' },
    footerContact: { he: 'צור קשר', en: 'Contact' },
    footerServiceTax: { he: 'הכנת דוחות מס אמריקאיים', en: 'U.S. Tax Return Preparation' },
    footerServiceFBAR: { he: 'דיווח FBAR', en: 'FBAR Reporting' },
    footerServiceStreamlined: { he: 'תהליך גילוי מרצון', en: 'Streamlined Filing Procedures' },
    footerServiceDual: { he: 'ייעוץ לבעלי אזרחות כפולה', en: 'Dual Citizenship Consulting' },
    jerusalem: { he: 'ירושלים:', en: 'Jerusalem:' },
    copyright: { he: '© 2024 LevitzTax. כל הזכויות שמורות.', en: '© 2024 LevitzTax. All rights reserved.' },
  },
};

export default translations;
